import React, { useCallback, useEffect, useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Mariana Ponce',
    location: 'CABA',
    text: 'Salgo del laburo fusilada y en 12–15 min tengo cena posta. Bajé a 1 pedido de delivery por semana y el aire de la airfryer labura a pleno. Las fotos ayudan un montón.'
  }, {
    name: 'Julián Álvarez',
    location: 'Rosario, SF',
    text: 'Soy de comer abundante y pensé que iba a quedarme con hambre. Nada que ver: porciones claras y tips para sumar proteína. El sándwich crocante de pollo es infalible.'
  }, {
    name: 'Camila Pereyra',
    location: 'Córdoba Capital',
    text: 'Tengo airfryer chica y cero balanza. Igual me salió todo. Me facilitó el tupper del mediodía y las colaciones para la facu. El apartado de swaps es oro.'
  }, {
    name: 'Diego Santillán',
    location: 'Mendoza',
    text: 'Lo compré por ansiedad de comer mejor sin cocinar horas. En dos semanas ya hice 18 recetas. La de bastoncitos de merluza + ensalada quedó top para los chicos.'
  }, {
    name: 'Valentina Godoy',
    location: 'San Miguel de Tucumán',
    text: "Mi miedo era el 'fit = insípido'. Todo lo contrario. Condimentos bien explicados, tiempos reales (cronómetro en mano). Y me encantó que tenga macros orientativas."
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const nextTestimonial = useCallback(() => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  }, [testimonials.length]);
  const prevTestimonial = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1);
  }, [testimonials.length]);
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        nextTestimonial();
      }, 5000);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [isPaused, nextTestimonial]);
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-353">
      <div className="max-w-7xl mx-auto" data-id="element-354">
        <div className="text-center mb-10" data-id="element-355">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-356">
            Lo que dicen quienes ya lo usan
          </h2>
          <div className="flex items-center justify-center gap-1 mb-2" data-id="element-357">
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-358" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-359" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-360" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-361" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-362" />
            <span className="ml-2 text-lg font-medium" data-id="element-363">4,9/5</span>
          </div>
          <p className="text-gray-600" data-id="element-364">Basado en reseñas verificadas</p>
        </div>
        <div className="relative max-w-3xl mx-auto" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-365">
          <div className="bg-gray-50 p-6 rounded-lg shadow-md mx-auto" data-id="element-366">
            <div className="flex items-center gap-1 mb-3" data-id="element-367">
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-368" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-369" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-370" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-371" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-372" />
            </div>
            <div className="mb-4 italic text-gray-700 min-h-[100px]" data-id="element-373">
              "{testimonials[currentIndex].text}"
            </div>
            <div className="flex items-center" data-id="element-374">
              <div className="bg-teal-100 h-10 w-10 rounded-full flex items-center justify-center mr-3" data-id="element-375">
                <span className="font-semibold text-teal-800" data-id="element-376">
                  {testimonials[currentIndex].name.charAt(0)}
                </span>
              </div>
              <div data-id="element-377">
                <p className="font-semibold text-gray-900" data-id="element-378">
                  {testimonials[currentIndex].name}
                </p>
                <p className="text-sm text-gray-600" data-id="element-379">
                  {testimonials[currentIndex].location}
                </p>
              </div>
            </div>
          </div>
          <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100" aria-label="Testimonio anterior" data-id="element-380">
            <ChevronLeftIcon className="h-6 w-6 text-gray-600" data-id="element-381" />
          </button>
          <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100" aria-label="Siguiente testimonio" data-id="element-382">
            <ChevronRightIcon className="h-6 w-6 text-gray-600" data-id="element-383" />
          </button>
          <div className="flex justify-center mt-4 gap-2" data-id="element-384">
            {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 w-2 rounded-full transition-colors duration-200 ${index === currentIndex ? 'bg-teal-600' : 'bg-gray-300'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-385" />)}
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-386">
          <p className="text-lg font-medium text-gray-700" data-id="element-387">
            8 de cada 10 usuarios lo utilizan 4+ veces por semana
          </p>
          <div className="flex justify-center mt-4" data-id="element-388">
            <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300" data-id="element-389">
              Quiero todo hoy solo por $19.990
            </a>
          </div>
        </div>
      </div>
    </section>;
};